import {action, makeAutoObservable, observable} from 'mobx';
import {DashboardSlotBacklight} from './DashboardSlotBacklight';
import {RefObject} from 'react';
import {SimpleWorkerListComponent} from '../DashboardScreen/WorkerList/SimpleWorkerList';
import {SectionWorkerListComponent} from '../DashboardScreen/WorkerList/SectionWorkerList';
import {wait} from 'fork-ts-checker-webpack-plugin/lib/utils/async/wait';
import {Dimensions, View} from 'react-native';
import {Layout} from './types';
import {Sentry} from '../Sentry';

export default class DashboardSlotBacklightImpl
  implements DashboardSlotBacklight
{
  @observable private _visible = false;
  @observable private _slotLayout: Layout | null = null;

  private _dashboardFlatList: RefObject<SimpleWorkerListComponent> | null =
    null;
  private _dashboardSectionList: RefObject<SectionWorkerListComponent> | null =
    null;
  private _slot: RefObject<View> | null = null;

  constructor() {
    makeAutoObservable(this);
    Dimensions.addEventListener('change', this._handleResize);
  }

  get visible() {
    return this._visible;
  }

  get slotLayout() {
    return this._slotLayout;
  }

  show = action(() => {
    wait(1000).then(() => {
      this._scroll();
      wait(1000).then(() => {
        if (!this._slot?.current) {
          return console.warn('Slot is not ready');
        }
        this._slot.current.measure((...args) => {
          if (args.some((arg) => arg === undefined) || args.length < 1) {
            Sentry.captureMessage(
              'Try to show slot backlight, but there are no coordinates',
            );
            this._visible = false;
            return;
          }
          const [, , width, height, pageX, pageY] = args;

          this._slotLayout = {
            width: Math.floor(width),
            height: Math.floor(height),
            pageX: Math.floor(pageX),
            pageY: Math.floor(pageY),
          };
          this._visible = true;
        });
      });
    });
  });
  @action
  private _handleResize = () => {
    if (!this._slot?.current) {
      return;
    }
    this._slot.current.measure((...args) => {
      const [, , width, height, pageX, pageY] = args;
      if ([width, height, pageX, pageY].some((v) => v == null)) {
        return;
      }

      this._slotLayout = {
        width: Math.floor(width),
        height: Math.floor(height),
        pageX: Math.floor(pageX),
        pageY: Math.floor(pageY),
      };
    });
  };

  close = action(() => {
    this._visible = false;
  });

  set dashboardFlatList(value: RefObject<SimpleWorkerListComponent>) {
    this._dashboardFlatList = value;
  }

  set dashboardSectionList(value: RefObject<SectionWorkerListComponent>) {
    this._dashboardSectionList = value;
  }

  set slot(value: RefObject<View>) {
    this._slot = value;
  }

  private _scroll() {
    this._dashboardFlatList?.current?.scrollToIndex({
      animated: false,
      index: 0,
      viewPosition: 0.5,
    });
    this._dashboardSectionList?.current
      ?.getScrollResponder()
      ?.scrollTo({y: 300, animated: false});
  }
}
